import { Dict } from "../apps/system/entity/SystemEntity";
import { globalDicts } from "../apps/system/service/DictService";

export class DictUtil {
  public static getItemName(dicts: Dict[], key: string | undefined) {
    if (key === null) {
      return "";
    }
    if (key === undefined) {
      return "";
    }
    if (key === "") {
      return "";
    }
    let result: string | undefined = "错误值";
    dicts.forEach(item => {
      if (item.itemKey === key) {
        result = item.itemValue;
        return result;
      }
    });
    return result;
  }

  public static getItemValue(code: string, key: string | undefined) {
    if (code === null) {
      return "";
    }
    if (code === undefined) {
      return "";
    }
    if (code === "") {
      return "";
    }
    if (key === null) {
      return "";
    }
    if (key === undefined) {
      return "";
    }
    if (key === "") {
      return "";
    }
    const result = globalDicts.get(code + key);
    if (result) {
      return result;
    } else {
      return "错误值";
    }
  }
}
